"use strict";

exports.__esModule = true;
exports.LogbookTicket = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _VimanaIcon = require("../../VimanaIcon");
var _Theme = require("../../Theme");
var _LogbookItemDescription = require("./LogbookItemDescription");
var _LogbookTicketDetails = require("../LogbookTicketDetails");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var LogbookItemWrapper = _styledComponents["default"].li.withConfig({
  displayName: "LogbookTicket__LogbookItemWrapper",
  componentId: "sc-10qm4f1-0"
})(["background:", ";"], function (props) {
  return props.theme.LogbookItemBackground;
});
var LogbookItem = _styledComponents["default"].div.withConfig({
  displayName: "LogbookTicket__LogbookItem",
  componentId: "sc-10qm4f1-1"
})(["display:flex;flex-direction:row;padding:0.5rem 0;margin:0 0.8rem;cursor:pointer;border-bottom:1px solid ", ";"], (0, _Theme.val)("LogbookBorderColor"));
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LogbookTicket__IconWrapper",
  componentId: "sc-10qm4f1-2"
})(["display:flex;flex:0 0 40px;justify-content:flex-start;align-items:center;padding:0.2rem 0 0;flex-direction:column;color:", ";"], function (props) {
  return props.theme.LogbookMutedTextColor;
});
var ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LogbookTicket__ContentWrapper",
  componentId: "sc-10qm4f1-3"
})(["width:100%;"]);
var LogbookTicket = exports.LogbookTicket = /*#__PURE__*/function (_Component) {
  function LogbookTicket() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      detailView: false,
      ticketDetails: null
    };
    _this.showDetailsView = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$props, logbook, ticket, ticketDetails;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this$props = _this.props, logbook = _this$props.logbook, ticket = _this$props.ticket;
            _context.n = 1;
            return logbook.getTicketDetails(ticket.id);
          case 1:
            ticketDetails = _context.v;
            _this.setState({
              detailView: true,
              ticketDetails: ticketDetails
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    _this.handleStatusClick = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(status) {
        var _this$props2, logbook, ticket, updateQuery, ticketDetails;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this$props2 = _this.props, logbook = _this$props2.logbook, ticket = _this$props2.ticket;
              updateQuery = {
                status: status
              };
              _context2.n = 1;
              return logbook.updateTicketDetails(ticket.id, updateQuery);
            case 1:
              ticketDetails = _context2.v;
              _this.setState({
                ticketDetails: ticketDetails
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    _this.handleSubmit = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(comment) {
        var _this$props3, logbook, ticket, ticketDetails;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this$props3 = _this.props, logbook = _this$props3.logbook, ticket = _this$props3.ticket;
              _context3.n = 1;
              return logbook.createTicketComment(ticket.id, comment);
            case 1:
              ticketDetails = _context3.v;
              _this.setState({
                ticketDetails: ticketDetails
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    _this.assignClick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var _this$props4, logbook, ticket, ticketDetails;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _this$props4 = _this.props, logbook = _this$props4.logbook, ticket = _this$props4.ticket;
            _context4.n = 1;
            return logbook.assignTicket(ticket.id);
          case 1:
            ticketDetails = _context4.v;
            _this.setState({
              ticketDetails: ticketDetails
            });
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    _this.hideDetailsView = function () {
      _this.setState({
        detailView: false
      });
    };
    _this.renderListView = function () {
      var ticket = _this.props.ticket;
      return /*#__PURE__*/_react["default"].createElement(LogbookItem, {
        onClick: _this.showDetailsView
      }, /*#__PURE__*/_react["default"].createElement(IconWrapper, null, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
        margin: "0",
        icon: "TicketsIcon",
        iconSize: 24,
        alt: "Ticket"
      })), /*#__PURE__*/_react["default"].createElement(ContentWrapper, null, /*#__PURE__*/_react["default"].createElement(_LogbookItemDescription.LogbookItemDescription, {
        title: ticket.title,
        creator: ticket.creator,
        created: ticket.created,
        id: ticket.id
      })));
    };
    _this.renderDetailView = function () {
      var logbook = _this.props.logbook;
      var ticketDetails = _this.state.ticketDetails;
      if (ticketDetails) {
        return /*#__PURE__*/_react["default"].createElement(_LogbookTicketDetails.LogbookTicketDetails, {
          onSubmit: _this.handleSubmit,
          onAssignClick: _this.assignClick,
          onStatusClick: _this.handleStatusClick,
          closeDetails: _this.hideDetailsView,
          ticket: ticketDetails,
          logbook: logbook
        });
      }
    };
    return _this;
  }
  _inheritsLoose(LogbookTicket, _Component);
  var _proto = LogbookTicket.prototype;
  _proto.render = function render() {
    var detailView = this.state.detailView;
    return /*#__PURE__*/_react["default"].createElement(LogbookItemWrapper, null, detailView ? this.renderDetailView() : this.renderListView());
  };
  return LogbookTicket;
}(_react.Component);